import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCLov, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useForm } from "react-hook-form";
import ModalSide from "src/components/Modal/styles";
import { standardErrorMessages } from "src/utils/errors";

export interface IRefModalRelateSprint {
    openModalRelateSprint: (action: number, phase: number, project: number, actionParentTitle: string, titleModal: string) => void;
}

interface IComponentModalRelateSprint{
    onCallbackSubmit: (idAction: number, idOldPhase: number, idNewPhase: number) => void;
}

const ModalsSubaction: React.ForwardRefRenderFunction<IRefModalRelateSprint, IComponentModalRelateSprint> = ({
	onCallbackSubmit
}, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const {addToast} = RCCHookToast();
    
	const [projectId, setProjectId] = useState<number | null>(null);
	const [actualPhase, setActualPhase] = useState<number | null>(null);
	const [actionId, setActionId] = useState<number | null>(null);

	const { 
		handleSubmit : handleSubmitAddOrChange, 
		control : controlAddOrChange,
		clearErrors : clearErrorsAddOrChange 
	} = useForm();

	// Modal Subactions
	const modalSubactions = useRef<RCCRefModalProps>(null);
	const [subtitle, setSubtitle] = useState("");
	const [title, setTitle] = useState("");
	
	const openModalRelateSprint = async (action: number, phase: number, project: number, actionParentTitle: string, titleModal: string) => {
		setActionId(action);
		setActualPhase(phase);
		setProjectId(project);
		setLoading(true);
		setSubtitle(`${translate("Ação")}: ${actionParentTitle}`);
		setTitle(titleModal);
		setLoading(false);
		modalSubactions.current?.openModal();	
	};

	const submitAddOrChange = async (data: any) => {
		const dataForm = {
			pra003Id: data.phase ? Number(data.phase) : "0",
			inb001Id: actionId
		};
	
		try{
			clearErrorsAddOrChange();
			modalSubactions.current?.setLoadingButton();
	
			await RCCServicesApi.postRequest({
				method: "ProjectPhase/UpdatePhaseAction",
				body: {
					...dataForm
				}
			});

			addToast({
				color: "green",
				description: translate("Ação movida com sucesso"),
				title: translate("Sucesso")
			});
				
			modalSubactions.current?.resetLoadingButton();
			modalSubactions.current?.closeModal();
	
			if(actionId && actualPhase)
				onCallbackSubmit(actionId, actualPhase, Number(data.phase) );

	
		}catch(err){
			modalSubactions.current?.resetLoadingButton();
			standardErrorMessages(err, translate("Erro ao mover ação"), addToast);
		}
	};
	
	useImperativeHandle(ref, () => ({
		openModalRelateSprint
	}));
    
	return (
		<>			
			{/* Modal ADD/CHANGE */}
			<Modal
				ref={modalSubactions}
				header={{
					title,
					icon: {
						name: "pencil"
					},
					subtitle	
				}}
				onSubmit={handleSubmitAddOrChange(submitAddOrChange)}
				styleInline={`${ModalSide} height: 400px; min-height: 400px;`}
			>
				<RCCLov 
					name="phase" 
					control={controlAddOrChange}
					routeAPI="ProjectPhase/Lov"
					valueProperty="Pra003Id"
					labelProperty="Pra003Titulo"
					elementsPerPage={20}
					extraParametersOnLoad={{
						projectId
					}}
					defaultValue={actualPhase ? String(actualPhase): undefined}
					placeholder={translate("Digite para filtrar as opções")}
				/>
			</Modal>
		</>
	);
};

export default forwardRef(ModalsSubaction);
